import { Box } from "@mui/material";

import strings from "../utils/strings.json";
import { theme } from "../utils/customColors";


function ErrorPage() {
  return (
      <Box sx={{ textAlign: "start", pb: 2, pr: 2, }}>
        <div style={{ fontSize: 24, color:theme.palette.primary.main, fontWeight:600 }}>{strings.errorPage.header1}</div>
        <div style={{ fontSize: 24, color:theme.palette.primary.main, fontWeight:600 }}> {strings.errorPage.header2}</div>
        <div style={{ fontSize: 24, color:theme.palette.primary.main, fontWeight:600 }}>{strings.errorPage.header3}</div>
      </Box>
  );
}

export default ErrorPage
